import swal from 'sweetalert';

export default ({
  t,
  type,
  payload,
  callback,
  textMessage,
  elementHTML,
  defaultValue,
  haveVariables = false
}) => {
  // const imgIcon = '/img/bg-popup.png';

  switch (type) {
    case 'success': {
      const options = {
        title: t('¡Éxito!'),
        icon: 'success',
        className: 'swall_icon_sucess',
        button: t('OK'),
        text: textMessage == '' ? t('SUCCESS_MESSAGE') : textMessage
      };
      if (payload) {
        options.text = payload;
      }
      return swal(options).then(() => callback && callback());
    }
    case 'warn': {
      const options = {
        title: '',
        text:
          textMessage == ''
            ? t('ERROR_MESSAGE')
            : haveVariables
            ? textMessage
            : t(textMessage),
        icon: 'warning',
        className: 'swall_icon_warning',
        button: t('OK')
      };
      if (payload) {
        const errorJson = JSON.parse(JSON.stringify(payload));
        if (errorJson.networkError) {
          const [err] = errorJson.networkError.result;
          options.text = t(err.Message);
        }
      }
      return swal(options).then(() => callback && callback());
    }
    case 'confirm': {
      const options = {
        text: textMessage,
        buttons: ['Cancelar', 'Aceptar'],
        closeOnClickOutside: false,
        icon: 'warning',
        className: 'swall_icon_warning'
      };
      return swal(options).then(willDelete => {
        if (willDelete) callback && callback();
      });
    }
    case 'content': {
      const options = {
        icon: 'warning',
        text: textMessage,
        buttons: ['Cancelar', 'Aceptar'],
        closeOnClickOutside: false,
        className: 'swall_icon_warning',
        content: {
          element: elementHTML,
          attributes: {
            defaultValue: defaultValue
          }
        }
      };
      return swal(options).then(function(value) {
        if (value === true || value === '') {
          const e = document.getElementsByClassName('option_select_wal')[0];
          const selelectedOption = e.options[e.selectedIndex].value;
          callback && callback(selelectedOption);
        }
      });
    }
    case 'warning': {
      const options = {
        title: t('WARNING_TITLE'),
        icon: 'warning',
        className: 'swall_icon_warning',
        text: textMessage == '' ? t('SUCCESS_MESSAGE') : textMessage
      };
      if (payload) {
        options.text = payload;
      }
      return swal(options).then(() => callback && callback());
    }
  }
};
